import { render, staticRenderFns } from "./WalletInfo.vue?vue&type=template&id=4aa1db8e&scoped=true&"
import script from "./WalletInfo.vue?vue&type=script&lang=ts&"
export * from "./WalletInfo.vue?vue&type=script&lang=ts&"
import style0 from "./WalletInfo.vue?vue&type=style&index=0&id=4aa1db8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa1db8e",
  null
  
)

export default component.exports